import './menuPerfilAcesso.css';
import React, { Component } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Row from '../common/layout/row';
import If from '../common/operator/if';
import Input from '../common/form/inputAuth';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { ThemeProvider } from '@material-ui/styles';
import imagemLogo from '../assets/images/logo_branca_vermelha.png';
import imagemLogoInfinitum from '../assets/images/logo_infinitum_vertical_branca.png';

import { getListaMenu } from './menuPerfilAcessoActions';
import { logout, alterarSenhaConfirmacao } from '../auth/authActions';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCard from '../common/template/contentCard';
import LabelAndInput from '../common/form/labelAndInput';
import Messages from '../common/msg/messages';


class MenuPerfilAcesso extends Component {
	constructor(props) {
		super(props);
		this.state = {
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight
		};

		document.title = 'Portal Infinitum';
	}

	componentWillMount() {
		this.props.getListaMenu();
	}

	componentDidMount() {
		this.handleResize = () => {
			this.setState({
				windowWidth: window.innerWidth,
				windowHeight: window.innerHeight
			});
		};
		window.addEventListener('resize', this.handleResize);
		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({
				registroConta: null
			});
		}
	};

	getStyles() {
		return makeStyles((theme) => ({
			paper: {
				marginTop: theme.spacing(8),
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			},
			avatar: {
				margin: theme.spacing(1),
				backgroundColor: theme.palette.secondary.main
			},
			form: {
				width: '100%',
				marginTop: theme.spacing(1),
			},
			submit: {
				margin: theme.spacing(3, 0, 2),
			},
		}));
	}

	getTheme() {

		return createMuiTheme({
			palette: {
				primary: {
					// light: será calculada com base em palette.primary.main,
					main: '#1f3269',
					// dark: será calculada com base em palette.primary.main,
					// contrastText: será calculada para contrastar com palette.primary.main
				},
				secondary: {
					light: '#0066ff',
					main: '#0044ff',
					// dark: será calculada com base palette.secondary.main,
					contrastText: '#ffcc00',
				},
				// Usado por `getContrastText()` para maximizar o contraste entre
				// o plano de fundo e o texto.
				contrastThreshold: 3,
				// Usado pelas funções abaixo para mudança de uma cor de luminância por aproximadamente
				// dois índices dentro de sua paleta tonal.
				// Por exemplo, mude de Red 500 para Red 300 ou Red 700.
				tonalOffset: 0.2,
			},
		});
	}

	render() {

		const classes = this.getStyles();

		let administrador = this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 1; //Administrador

		let escala = 1;
		if (this.state.windowWidth >= 1810) {
			escala = 1;
		} else if (this.state.windowWidth >= 1700) {
			escala = 0.9;
		} else if (this.state.windowWidth >= 1500) {
			escala = 0.82;
		} else if (this.state.windowWidth >= 1000) {
			escala = 0.7;
		} else if (this.state.windowWidth >= 661) {
			escala = 0.6;
		} else if (this.state.windowWidth >= 567) {
			escala = 0.52;
		} else if (this.state.windowWidth >= 378) {
			escala = 0.5;
		} else if (this.state.windowWidth >= 350) {
			escala = 0.48;
		} else {
			escala = 0.46;
		}

		return (
			<ThemeProvider theme={this.getTheme()}>
				<CssBaseline />

				{this.modalConta()}

				<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#1f3269', minHeight: this.state.windowHeight, padding: 40 * escala }}>					
					<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: 20 }}>
						
						<div class='input-group' style={{ width: this.state.windowWidth - (350 * escala) }}>
							<div class='input-group-prepend'>
								<span class='input-group-text'
									style={{
										backgroundColor: '#ffffff',
										color: '#1f3269'
									}}><i class='fas fa-search'></i></span>
							</div>
							<input type='text' class='form-control' placeholder='Pesquisar'
								style={{
									backgroundColor: '#1f3269',
									color: '#ffffff'
								}}
								value={this.state.pesquisa}
								onChange={data => this.setState({ pesquisa: data.target.value })} />
						</div>

						<img src={imagemLogo} style={{ width: 230 * escala }}/>
					</div>
					
					<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
						{this.props.listaMenu.filter(menu => {
							if (!(this.state.pesquisa || '').trim()) {
								return true;
							}

							return (menu.palavras_chave || []).filter(palavra => {
									return palavra.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()
										.includes(this.state.pesquisa.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase());
								}).length 
								||  menu.nome.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()
									.includes(this.state.pesquisa.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase());
						}).map(menu => {

							return (
								<a key={menu.id} class={menu.liberado ? 'menu-portal-item' : null}
									href={menu.liberado && menu.tela_padrao ? (menu.tela_padrao.rota ? `/#${menu.tela_padrao.rota}` : menu.tela_padrao.link) : ''}
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										width: 150 * escala,
										height: 150 * escala,
										margin: 8 * escala,
										padding: 8 * escala,
										backgroundColor: '#4472c4',
										borderRadius: 3 * escala, 
										textAlign: 'center',
										opacity: menu.liberado ? 1 : 0.4,
										cursor: menu.liberado ? 'pointer' : 'not-allowed'
									}}
									onClick={(e) => {
										e.preventDefault();
										if (!menu.liberado) {
											//Sem acão	
										} else if (menu.tela_padrao && menu.tela_padrao.rota) {											
											window.location = `/#${menu.tela_padrao.rota}`;
											window.location.reload();
										} else if (menu.tela_padrao && menu.tela_padrao.link) {
											window.open(menu.tela_padrao.link, '_blank');
										}
									}}>
									<i style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: 32 * escala, color: '#ffffff', height: 80 }} class={menu.icone}></i>

									<h1 style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: 16 * escala, color: '#ffffff', height: 80 }}>{menu.nome}</h1>
								</a>
							);
						})}
					</div>
					<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
						<img src={imagemLogoInfinitum} style={{ width: 150 * escala, marginTop: 20 * escala }}/>
					
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'flex-end',
							}}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									width: 100 * escala,
									height: 100 * escala,
									marginTop: 30,
									textAlign: 'center',
									opacity: 1,
									cursor: 'pointer'
								}}
								onClick={() => {
									this.setState({
										registroConta: {
											id: this.props.sessao.id,
											nome: this.props.sessao.nome,
											login: this.props.sessao.login
										}
									});
								}}>
								<i style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: 32 * escala, color: '#ffffff', height: 40 * escala }} class={'fas fa-user-cog'}></i>

								<h1 style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: 16 * escala, color: '#ffffff', height: 30 * escala }}>Conta</h1>
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									width: 100 * escala,
									height: 100 * escala,
									marginTop: 30,
									textAlign: 'center',
									opacity: 1,
									cursor: 'pointer'
								}}
								onClick={() => {
									this.props.logout();
									window.location.reload();
								}}>
								<i style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: 32 * escala, color: '#ffffff', height: 40 * escala }} class={'fas fa-sign-out-alt'}></i>

								<h1 style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: 16 * escala, color: '#ffffff', height: 30 * escala }}>Sair</h1>
							</div>
						</div>
					</div>
				</div>
				
				<Messages />

			</ThemeProvider>
		);
	}

	modalConta() {
	
			if (!this.state.registroConta) {
				return;
			}
	
			return (
				<>
					<div className="modal-backdrop fade show" />
					<div class='modal fade show'
						id='modal-md'
						style={{ display: 'block' }}
						aria-modal='true'>
						<div class='modal-dialog modal-md' style={{ }}>
							<div class='modal-content' style={{ backgroundColor: '#1F3066' }}>
								<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
									<h4 class='modal-title'>Conta</h4>
									<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
										onClick={() => this.setState({ registroConta: null })}>
										<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
									</button>
								</div>
								<div class='modal-body' style={{ padding: 2 }}>
									<ContentCard style={{ }}>
										<ContentCardBody style={{ padding: 16 }}>
											<Row>
												<LabelAndInput
													name='nome'
													label='Nome *'
													placeholder='Informe o Nome'
													cols='12 12 12 12'
													value={this.state.registroConta.nome}
													readOnly={'readOnly'}
													onChange={data => {
														// this.setState({
														// 	registroConta: {
														// 		...this.state.registroConta,
														// 		nome: data.target.value
														// 	}
														// });
													}} />
											
												<LabelAndInput
													component={LabelAndInput}
													label='Login *'
													placeholder='Informe o Usuário'
													cols='12 12 12 12'
													readOnly={'readOnly'}
													value={this.state.registroConta.login}
													onChange={data => {}} />


												<LabelAndInput
													type='password'
													label='Senha Atual *'
													placeholder='Informe a senha atual'
													cols='12 12 12 12'
													value={this.state.registroConta.senha_atual}
													onChange={data => {
														this.setState({
															registroConta: {
																...this.state.registroConta,
																senha_atual: data.target.value
															}
														});
													}} />

												<LabelAndInput
													type='password'
													label='Senha *'
													placeholder='Informe a confrirmação de senha'
													cols='12 12 12 12'
													value={this.state.registroConta.senha}
													onChange={data => {
														this.setState({
															registroConta: {
																...this.state.registroConta,
																senha: data.target.value
															}
														});
													}} />

												<LabelAndInput
													type='password'
													label='Confirme a Senha *'
													placeholder='Informe a senha'
													cols='12 12 12 12'
													value={this.state.registroConta.senha_confirmacao}
													onChange={data => {
														this.setState({
															registroConta: {
																...this.state.registroConta,
																senha_confirmacao: data.target.value
															}
														});
													}} />
											</Row>

											<Row alignCenter style={{ padding: 16 }}>
												<Grid cols='12 12 12 12'>
													<button 
														type='button'
														class='btn btn-block btn-dark btn-flat'
														disabled={!this.state.registroConta.senha || this.state.registroConta.senha != this.state.registroConta.senha_confirmacao}
														onClick={() => {
															if (this.state.registroConta.senha && this.state.registroConta.senha == this.state.registroConta.senha_confirmacao) {
																this.props.alterarSenhaConfirmacao({
																	...this.state.registroConta
																}, () => this.setState({ registroConta: null }));
															}
														}}>
														Alterar Senha 
													</button>
												</Grid>
											</Row>
										</ContentCardBody>
									</ContentCard>
								</div>
							</div>
						</div>
					</div>
				</>
			);
		}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	listaMenu: state.menuPerfilAcesso.listaMenu
});
const mapDispatchToProps = dispatch => bindActionCreators({ getListaMenu, logout, alterarSenhaConfirmacao }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MenuPerfilAcesso);
